import styled from "styled-components";

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${props => props.theme.white1};
  height: 100vh;
`;

export const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow-x: hidden; /* 외부 가로 스크롤 방지 */
  overflow-y: auto;
  margin-left: 0;
`;

export const MenuContainer = styled.div`
  padding: 12px 20px;
  background-color: ${props => props.theme.white1};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
`;

export const OptionContainer = styled.div`

  margin: 20px;
`;

export const SearchContainer = styled.div`
  display: flex;
  margin: 12px 0;
  padding: 12px 20px;
  background-color: ${props => props.theme.white2};
  position: relative;
  border-radius: 10px;
  align-items: center;

`;

export const FilterContainer = styled.div`
  display: table;
`;

export const TableHeaderCell = styled.div`
  display: table-cell;
  padding: 8px;
  text-align: center;
  border: 1px solid ${props => props.theme.white4};
  font-weight: bold;
  max-width: 150px;
  min-width: 100px;

  &:not(:last-child) {
  }
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
`;

export const ListContainer = styled.div`
  width: 38%;
  min-width: 300px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white4};
  margin: 20px 20px 20px 0px;
  background-color: ${props => props.theme.white1};
  height: calc(100vh - 40px);
  font-size: 20px;
  text-align: left;
  padding-right: 10px;
  border-radius: 7px;
  overflow-y: scroll;
`;

export const ListHeader = styled.div`
  padding: 20px 0 0 20px;
  position: relative;
  display: flex;
`;

export const ListInfoContainer = styled.div`
  padding: 20px;
  position: relative;
  h3,h4,h5,h6{
    margin: 0;
  }
  h6{
    font-size: 14px;
    font-weight: 400;
  }
  p{
    font-size: 14px;
    font-weight: 500;
    margin: 0;
  }
  nav{
    margin-bottom: 10px;

  }
  span{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const Table = styled.table`
  margin-top: 10px;
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.th`
  border: 1px solid ${props => props.theme.white5};;
  padding: 5px;
  text-align: center;
  font-size: 14px;
`;

export const TableData = styled.td`
  border: 1px solid ${props => props.theme.white5};
  padding: 2px;
  font-size: 13px;
  text-align: center;
`;

export const Button = styled.button`
  background-color: ${props => props.theme.colorwhite2};
  width: 180px;
  height: 40px;
  border-radius: 5px;
  border: 0;
  color: unset;
  &:focus {
    outline: none;
  }
  &:hover{
    background-color: ${props => props.theme.white5};
  }
`;